import React from "react";
import { STAT_ICONS, StatItem } from "modules/common/components/stats/StatItem";

export function CollectionAppraisalSkeleton() {
  return (
    <div className="flex flex-col gap-0">
      <div className="divide-base-300/20 border-base-content/20 bg-base-100 shadow-xs flex w-full flex-col divide-x-0 divide-y rounded-[var(--radius-box)] border">
        <StatItem
          figure={STAT_ICONS.CARDS}
          title="Cards"
          value={<div className="skeleton h-8 w-12" />}
          description={<div className="skeleton h-5 w-20" />}
        />
        <StatItem
          figure={STAT_ICONS.VALUE}
          title="Value"
          value={<div className="skeleton h-8 w-16" />}
        />
      </div>
    </div>
  );
}
